import React, { CSSProperties, ReactNode } from 'react';
import * as DropdownMenuLibrary from '@radix-ui/react-dropdown-menu';
import * as S from './styles';
import styled, { css } from 'styled-components';

export type DropdownMenuSize = 1 | 2;
export type DropdownMenuVariant = 'solid' | 'soft';
export type DropdownMenuType = 'default' | 'checkbox' | 'radio';

export type DropdownMenuProps = {
  $size: DropdownMenuSize;
  $variant: DropdownMenuVariant;
  $highContrast: boolean;
  $type: DropdownMenuType;
  $triggerDropdownMenu: ReactNode;
  $contentDropdownMenu: ReactNode;
  style?: CSSProperties;
  $sideOffset?: number;
  $alignOffset?: number;
  $funcaoParaExecutarAposAbertura?: () => void;
  $alignStartDropdownMenu?: 'center' | 'start' | 'end';
};

export const DropdownMenuItem = styled(DropdownMenuLibrary.Item)<{
  $size: number;
  $selected?: boolean;
  $corFundoSelecionado?: string;
  $corFundoHover?: string;
}>`
  cursor: pointer;

  ${({ theme, $size }) => {
    return css`
      padding-top: ${theme.spacing[$size]}px;
      padding-right: ${theme.spacing['3']}px;
      padding-bottom: ${theme.spacing[$size]}px;
      padding-left: ${theme.spacing['3']}px;
      gap: ${theme.spacing['2']}px;
    `;
  }}
  ${({ theme, $size }) => {
    return css`
      font-size: ${theme.typography.font.size[$size]}px;
      font-family: var(--font-${theme.typography.font.family.text});
      font-weight: ${theme.typography.font.weight.medium};
      line-height: ${theme.typography.font.line_height[$size]}px;
      text-align: left;
      color: ${theme.tokens.colors.text};
    `;
  }}

  &:hover {
    ${({ $selected, $corFundoHover }) => {
      if ($selected || !$corFundoHover) return '';
      return css`
        background-color: ${$corFundoHover};
      `;
    }}
  }

  ${({ $selected, $corFundoSelecionado }) => {
    if (!$selected || !$corFundoSelecionado) return '';
    return css`
      background-color: ${$corFundoSelecionado};
    `;
  }}
`;

export default function DropdownMenu(props: DropdownMenuProps) {
  const {
    $triggerDropdownMenu,
    $sideOffset = 0,
    $alignOffset = 0,
    $contentDropdownMenu,
    $funcaoParaExecutarAposAbertura = () => {},
    $alignStartDropdownMenu = 'start',
  } = props;

  function lidarAberturaDoDropdown(estaAberto: boolean) {
    if (estaAberto) {
      $funcaoParaExecutarAposAbertura();
    }
  }

  return (
    <DropdownMenuLibrary.Root onOpenChange={lidarAberturaDoDropdown}>
      <DropdownMenuLibrary.Trigger asChild>
        {$triggerDropdownMenu}
      </DropdownMenuLibrary.Trigger>
      <S.DropdownMenuConteudo
        sideOffset={$sideOffset}
        alignOffset={$alignOffset}
        align={$alignStartDropdownMenu}
        {...props}
      >
        {$contentDropdownMenu}
      </S.DropdownMenuConteudo>
    </DropdownMenuLibrary.Root>
  );
}
